import { useId, useState } from 'react';

export default function GlossaryHint({ term, meaning }: { term?: string; meaning: string }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <span className="relative inline-flex">
      <button type="button" aria-expanded={open} aria-controls={id} onClick={() => setOpen((v) => !v)} className="text-xs font-bold text-[#d6006e] underline decoration-dotted underline-offset-2">
        {term || 'What this means'}
      </button>
      {open && (
        <span id={id} role="tooltip" className="absolute left-0 top-full z-20 mt-2 w-64 rounded-xl border border-[#f9c0d8] bg-white p-3 text-left text-xs font-normal leading-relaxed text-[#4a1a30] shadow-xl">
          {meaning}
        </span>
      )}
    </span>
  );
}
